module.exports = __webpack_public_path__ + "img/firewall.4cc41ea.svg";